<template>
    <div class="home">
        <div class="container">
            <h1 class="title">首页</h1>
            <p class="lead"></p>
        </div>
    </div>
</template>
<script >
    export default {
        name: "home",
        created() {
            if(this.$route.query.isfirst){
                this.$notify({
                    type: 'info',
                    title: '欢迎使用管理操作系统',
                    message: '如有问题，联系客服',
                    offset: 100
                });
            }
        }
    }
</script>
<style>
    .home {
        width: 100%;
        height: 100%;
        background: url(../assets/showcase.png) no-repeat;
        background-size: 100% 100%;
    }
    .container {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-top: 100px;
        background-color: rgba(0, 0, 0, 0.7);
        text-align: center;
        color: white;
    }
    .title {
        font-size: 30px;
    }
    .lead {
        margin-top: 50px;
        font-size: 22px;
    }
</style>
